/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useMotivo = ({ formikRef, name = "motivoId" }) => {
  const motivoSelect = useSelect("motivo");
  const [fila, setFila] = useState(null);
  const [motivo, setMotivo] = useState(0);

  const [motivos, setMotivos] = useState([]);

  useEffect(() => {
    const fetchMotivos = async () => {
      const result = [];
      await db.motivo.filter((a) => a.ativo).each((item) => result.push(item));
      setMotivos(result);
    };

    fetchMotivos();
  }, []);

  const optionMotivos = useMemo(() => prepareForOptions(motivos, ['codigo', 'descricao'], 'id'), [motivos]);

  function onChangeMotivo(e) {
    motivoSelect.upDateValue(e.value);
    motivoSelect.upDateDefaultValue(e || "");
    formikRef.current.setFieldValue(name, e.value);
    setTimeout(() => formikRef.current.setFieldTouched(name, true));
    setMotivo(e.value);
  }

  function SetSelectMotivoComercial(id) {
    if (optionMotivos?.length) {
      const motivo = optionMotivos.find((o) => o.value === id);
      if (motivo)
        onChangeMotivo(motivo);

      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionMotivos?.length > 0) {
      SetSelectMotivoComercial(fila);
    }
  }, [fila, optionMotivos])

  return {
    motivos,
    optionMotivos,
    onChangeMotivo,
    SetSelectMotivoComercial,
    motivo,
    motivoSelect,
    setMotivo
  };
}

export default useMotivo;